const en = {
	shortMessage: 'short message',
	recordList: 'record list',
	phoneNumber: 'phone number',
	moduleId: 'module id',
	parameter: 'parameter',
	sendTime: 'send time',
	WeChat: 'WeChat',
	content: 'content',
	messageRecord: 'message  record',
};

export default en;
